import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CountriesComponent from "../countries";
import { useTranslation } from "react-i18next";
import CustomSelect from "../custom-components/select";
import { getActionType } from "../../../Redux/reducer/logs";
import { getUserTypes } from "../../../Redux/reducer/users";
import DatePicker, { registerLocale } from "react-datepicker";
import { getSessionInfo } from "../../../Redux/reducer/session";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { loadingModal, formatDashDate } from "../../utils/functions";
import { getActionTypes, getAllLogs } from "../../../Redux/actions/logsAction";
import { getUserTypes as getUserTypesAction } from "../../../Redux/actions/userActions";
import ProviderFilters from "./types/providerFilters";

import es from "date-fns/locale/es";
import LogsIco from "../../../../static/images/logs-ico.svg";

const FiltersComponent = (props) => {
  const { t } = useTranslation();
  const now = new Date();
  const filterObj = {
    countryId: "",
    cif: "",
    userType: "",
    companyName: "",
    createBy: "",
    severity: "",
    action: "",
    fromDate: now.setDate(now.getDate() - 7),
    toDate: new Date(),
  };

  const severity = [
    { name: `${t("general.states.SUCCESS")}`, code: "SUCCESS" },
    { name: `${t("general.states.ERROR")}`, code: "ERROR" },
  ];

  registerLocale("es", es);
  const dispatch = useDispatch();
  const [filters, setFilters] = useState(filterObj);
  const [modal, setModal] = useState({ show: false });
  const actionTypes = useSelector((state) => getActionType(state));
  const userTypes = useSelector((state) => getUserTypes(state));
  const loggedUser = useSelector((state) => getSessionInfo(state));

  useEffect(() => {
    async function fecthData() {
      return await dispatch(getActionTypes());
    }

    async function fetchUserTypes() {
      return await dispatch(getUserTypesAction());
    }

    fecthData();
    fetchUserTypes();
  }, []);

  const clearState = () => {
    setFilters(filterObj);
  };

  const updateDate = (date, obj) => {
    filters[obj] = date;
    setFilters({ ...filters });
  };

  const handlerChange = (event) => {
    filters[event.target.name] = event.target.value;
    setFilters({ ...filters });
  };

  const getLogs = () => {
    setModal({ show: true });
    var logFilters = [];

    Object.keys(filters).map((key) => {
      if (filters[key] !== "") {
        switch (key) {
          case "action":
            logFilters.push({
              value: filters[key],
              property: key,
              operator: "eq",
            });
            break;
          case "countryId":
            logFilters.push({
              value: filters[key],
              property: "country",
              operator: "eq",
            });
            break;
          case "companyName":
            logFilters.push({
              value: encodeURIComponent(filters[key]),
              property: key,
              operator: "eq",
            });
            break;
          case "fromDate":
            logFilters.push({
              value: formatDashDate(filters[key]),
              property: "createDate",
              operator: "ge",
            });
            break;
          case "toDate":
            var newDate = new Date(filters[key]);
            newDate.setDate(newDate.getDate() + 1);
            logFilters.push({
              value: formatDashDate(newDate),
              property: "createDate",
              operator: "le",
            });
            break;
          default:
            logFilters.push({
              value: encodeURI(filters[key]),
              property: key,
              operator: "eq",
            });
        }
      }
      return true;
    });

    return dispatch(getAllLogs(0, 10, loggedUser.userType, logFilters)).then(
      () => {
        setModal({ show: false });
        props.setFilters(logFilters);
        props.loadLogs();
      }
    );
  };

  return (
    <div id="filters-container">
      <div className="header-providers">
        <div className="title">
          <img
            className="iconList"
            src={LogsIco}
            style={{ width: "30px" }}
          />
          <p className="p-list">{t("logs.filters.title")}</p>
        </div>
      </div>

      {loggedUser.userType === "PRO" ? (
        <ProviderFilters
          filters={filters}
          handlerChange={handlerChange}
          updateDate={updateDate}
        />
      ) : (
        <div className="filters">
          <div className="row">
            {loggedUser.userType === "BSC" && (
              <div className="input col-lg-4">
                <label htmlFor="countryId">
                  {t("logs.filters.form.country.label")}
                </label>
                <CountriesComponent
                  name="countryId"
                  value={filters.countryId}
                  valueAttr={`code`}
                  onChange={handlerChange}
                />
              </div>
            )}
            <div className={`input col-lg-4`}>
              <label htmlFor="cif">{t("logs.filters.form.cif.label")}</label>
              <input
                type="text"
                id="cif"
                name="cif"
                value={filters.cif}
                onChange={(e) => handlerChange(e)}
                placeholder={t("logs.filters.form.cif.placeholder")}
              />
              <span className="info">{t("logs.filters.form.optional")}</span>
            </div>
            <div className={`input col-lg-4`}>
              <label htmlFor="companyName">
                {t("logs.filters.form.companyName.label")}
              </label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={filters.companyName}
                onChange={(e) => handlerChange(e)}
                placeholder={t("logs.filters.form.companyName.placeholder")}
              />
              <span className="info">{t("logs.filters.form.optional")}</span>
            </div>
          </div>
          <div className="row">
            <div className="input col-lg-4">
              <label htmlFor="createBy">
                {t("logs.filters.form.createBy.label")}
              </label>
              <input
                type="text"
                id="createBy"
                name="createBy"
                value={filters.createBy}
                onChange={(e) => handlerChange(e)}
                placeholder={t("logs.filters.form.createBy.placeholder")}
              />
            </div>
            {loggedUser.userType === "BSC" && (
              <div className="input col-lg-4">
                <label htmlFor="userType">
                  {t("logs.filters.form.userType.label")}
                </label>
                <CustomSelect
                  id="userType"
                  items={userTypes}
                  name="userType"
                  value={filters.userType}
                  valueAttr={`code`}
                  handleChange={handlerChange}
                />
              </div>
            )}
            <div className="input col-lg-4">
              <label htmlFor="severity">
                {t("logs.filters.form.severity.label")}
              </label>
              <CustomSelect
                placeholder={t("logs.filters.form.severity.placeholder")}
                id="severity"
                items={severity}
                name="severity"
                value={filters.severity}
                valueAttr={`code`}
                handleChange={handlerChange}
              />
              <span className="info">{t("logs.filters.form.optional")}</span>
            </div>
          </div>
          <div className="row">
            <div className="input col-lg-4">
              <label className="fake-title" htmlFor="action">
                .
              </label>
              <CustomSelect
                id="transactionType"
                placeholder={t("logs.filters.form.transactionType.placeholder")}
                items={actionTypes}
                name="action"
                value={filters.action}
                valueAttr={`name`}
                handleChange={handlerChange}
              />
              <span className="info">{t("logs.filters.form.optional")}</span>
            </div>
            <div className="input col-lg-4">
              <label htmlFor="fromDate">
                {t("logs.filters.form.since.label")}
              </label>
              <DatePicker
                id="fromDate"
                name="fromDate"
                selected={filters.fromDate}
                onChange={(date) => updateDate(date, "fromDate")}
                showMonthDropdown
                showYearDropdown
                showPopperArrow={false}
                dropdownMode="scroll"
                locale="es"
              />
              <span className="info">{t("logs.filters.form.optional")}</span>
            </div>
            <div className="input col-lg-4">
              <label htmlFor="toDate">
                {t("logs.filters.form.until.label")}
              </label>
              <DatePicker
                id="toDate"
                name="toDate"
                selected={filters.toDate}
                onChange={(date) => updateDate(date, "toDate")}
                showMonthDropdown
                showYearDropdown
                showPopperArrow={false}
                dropdownMode="scroll"
                locale="es"
              />
              <span className="info">{t("logs.filters.form.optional")}</span>
            </div>
          </div>
        </div>
      )}
      <div className="form-actions clearfix">
        <SecondaryButton id="clear-btn" onClick={clearState}>
          {t("general.buttons.clear")}
        </SecondaryButton>
        {/* <button id="clear-btn" className="button button--pill" onClick={() => clearState()}>{t('general.buttons.clear')}</button> */}
        <SecondaryButton id="continue-btn" onClick={getLogs}>
          {t("general.buttons.continue")}
        </SecondaryButton>
        {/* <button id="continue-btn" className="button button--pill" onClick={() => getLogs()}>{t('general.buttons.continue')}</button> */}
      </div>
      {modal.show && loadingModal()}
    </div>
  );
};

export default FiltersComponent;
